import ArtistsFull from "../components/ArtistsFull";
import ArtistsMobile from "../components/ArtistsMobile";
import { useMediaQuery } from "@mui/material";
import { useEffect } from "react";

export default function Artists() {

    const galleryDevice = useMediaQuery('(min-width:3000px)');

    useEffect(() => {
        window.gtag('event', 'page_view', {
                page_title: 'Artists',
                page_location: 'https://apps.discovernewfields.org/we-the-culture/artists',
                gallery_device: galleryDevice,
                send_to: 'G-PC1LP4S0D0'
        });
    }, [galleryDevice])
    
    const mobileDevice = useMediaQuery('(max-width:1025px)');
    return (
        mobileDevice ? <ArtistsMobile /> : <ArtistsFull />
    )
};
